export default __webpack_public_path__ + "static/media/OptionCountsClusters.24dfb0be.png";